{
  "name": "superstreaming.backend",
  "version": "0.2.0",
  "description": "Backend for SuperStreaming app",
  "license": "MIT",
  "scripts": {
    "start": "ng serve",
    "start:prod": "ng serve --configuration production",
    "watch": "ng build --watch --configuration development",
    "build:dev": "ng build --configuration development",
    "build": "ng build --configuration production",
    "build:dev-spiin": "ng build --configuration development-spiin",
    "build:prod-spiin": "ng build --configuration production-spiin",
    "predeploy:dev": "npm run git-postcommit && npm run build:dev",
    "predeploy:prod-spiin": "npm run git-postcommit && npm run build:prod-spiin",
    "predeploy": "npm run git-postcommit && npm run build",
    "predeploy:dev-spiin": "npm run git-postcommit && npm run build:dev-spiin",
    "deploy:dev": "firebase deploy --only hosting:dev --project dev",
    "deploy": "firebase deploy --only hosting:prod --project prod",
    "deploy:prod-spiin": "firebase deploy --only hosting:prod-spiin --project prod-spiin",
    "deploy:dev-spiin": "firebase deploy --only hosting:dev-spiin --project dev-spiin",
    "fb:login": "firebase login --reauth",
    "test": "ng test",
    "e2e": "ng e2e",
    "login": "firebase login --reauth",
    "update-types": "cd src/app/consts/types && git pull",
    "git-postcommit": ".git/hooks/post-commit && cat gitinfos.json"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.0",
    "@angular/cdk": "^19.2.1",
    "@angular/common": "^19.2.0",
    "@angular/compiler": "^19.2.0",
    "@angular/core": "^19.2.0",
    "@angular/fire": "^19.0.0",
    "@angular/forms": "^19.2.0",
    "@angular/google-maps": "^19.2.1",
    "@angular/material": "^19.2.1",
    "@angular/material-moment-adapter": "^19.2.1",
    "@angular/platform-browser": "^19.2.0",
    "@angular/platform-browser-dynamic": "^19.2.0",
    "@angular/router": "^19.2.0",
    "@auth0/angular-jwt": "^5.2.0",
    "@fullcalendar/angular": "^6.1.16",
    "@fullcalendar/core": "^6.1.15",
    "@fullcalendar/daygrid": "^6.1.15",
    "@fullcalendar/interaction": "^6.1.15",
    "@fullcalendar/timegrid": "^6.1.15",
    "@shopify/graphql-client": "^1.3.0",
    "@tailwindcss/postcss": "^4.0.9",
    "angular-calendar": "^0.31.1",
    "angular-draggable-droppable": "^8.0.0",
    "apexcharts": "^3.54.1",
    "date-fns": "^2.30.0",
    "nanoid": "^5.1.2",
    "ngx-toastr": "^19.0.0",
    "postcss": "^8.5.3",
    "rxfire": "^6.1.0",
    "rxjs": "^7.8.2",
    "tailwindcss": "^4.0.9",
    "tslib": "^2.8.1",
    "uuid": "^9.0.1",
    "vest": "4.6.11",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.0",
    "@angular/cli": "^19.2.0",
    "@angular/compiler-cli": "^19.2.0",
    "@angularclass/hmr": "^3.0.0",
    "@eslint/js": "^9.21.0",
    "@ianvs/prettier-plugin-sort-imports": "^4.4.1",
    "@trivago/prettier-plugin-sort-imports": "^4.3.0",
    "@types/eslint__js": "^8.42.3",
    "@types/google.accounts": "^0.0.14",
    "@types/jasmine": "~4.3.6",
    "@types/node": "^22.13.8",
    "@typescript-eslint/eslint-plugin": "^7.18.0",
    "@typescript-eslint/parser": "^7.18.0",
    "copyfiles": "^2.4.1",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.2.3",
    "globals": "^15.15.0",
    "jasmine-marbles": "~0.9.2",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.1.1",
    "karma-coverage": "~2.1.1",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "karma-jasmine": "~4.0.2",
    "karma-jasmine-html-reporter": "~1.7.0",
    "prettier": "^3.5.3",
    "prettier-eslint": "^16.3.0",
    "ts-node": "~10.9.2",
    "typescript": "~5.7.3",
    "typescript-eslint": "^7.18.0"
  }
}
